import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { Applications, Bookings, Tickets } from "@/components/admin/AdminOps";
import { Overview, Transactions, Users, Activities, Settings, AuditLog } from "@/components/admin/AdminData";
import { ChangePassword } from "@/components/ChangePassword";

export default function Admin() {
  const { user } = useAuth();
  const tab = useSearchParams()[0].get("tab");
  const can = (p) => user.perms.includes(p);
  const tabs = [
    ["overview", "Reports", "reports", <Overview />],
    ["applications", "Applications", "applications", <Applications />],
    ["bookings", "Bookings", "bookings", <Bookings canRefund={can("refunds")} />],
    ["tickets", "Complaints & Disputes", "complaints", <Tickets />],
    ["transactions", "Transactions", "transactions", <Transactions />],
    ["users", "Users", "users", <Users />],
    ["activities", "Activities", "activities", <Activities />],
    ["settings", "Pricing & Commission", "settings", <Settings />],
    ["audit", "Audit log", "audit", <AuditLog />],
    ["password", "Password", null, <ChangePassword />],
  ].filter((t) => !t[2] || can(t[2]));

  return (
    <div className="container-x w-full min-w-0 py-10 space-y-6" data-testid="admin-dashboard">
      <div>
        <p className="eyebrow">{user.role} console</p>
        <h1 className="text-4xl sm:text-5xl font-bold mt-1">Admin dashboard</h1>
        <p className="text-sm text-slate-500 mt-1 break-words">Signed in as {user.email} · role-based access: {user.perms.join(", ")}</p>
      </div>
      <Tabs defaultValue={tabs.some((x) => x[0] === tab) ? tab : tabs[0][0]} key={tab || "default"}>
        <TabsList className="flex flex-wrap h-auto justify-start max-w-full">
          {tabs.map(([k, l]) => <TabsTrigger key={k} value={k} data-testid={`admin-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        {tabs.map(([k, , , el]) => <TabsContent key={k} value={k} className="mt-6">{el}</TabsContent>)}
      </Tabs>
    </div>
  );
}
